module.exports = __webpack_public_path__ + "img/basketball.f5897d14.png";